"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var ScrollToTopOnMount = function ScrollToTopOnMount(props) {
  var scrollToTop = function scrollToTop() {
    return window.scrollTo(100, 0);
  };

  (0, _react.useEffect)(function () {
    scrollToTop();
  }, []);
  (0, _react.useEffect)(function () {
    scrollToTop();
  }, [props.location.pathname]);
  return null;
};

var _default = (0, _reactRouterDom.withRouter)(ScrollToTopOnMount);

exports["default"] = _default;